import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/sapi/v4/account/";

//获取收藏列表
export function get_symbolStar(config?) {
  return XtAxios4.get(URL + `symbol-star/list`, config);
}

//加入收藏列表
export function post_symbolStar(config?) {
  return XtAxios4.post(URL + `symbol-star/add`, null, config);
}

//取消收藏列表
export function delete_symbolStarId(id, config?) {
  return XtAxios4.delete(URL + `symbol-star/cancel/${id}`, config);
}
